module.exports = __webpack_public_path__ + "img/fun4.90b25d71.png";